export const selectContractsState = state => state.contracts;
export const selectContracts = state => state.contracts.contracts;
export const selectContractById = (state, contractId) =>
  state.contracts.contracts.find(contract => contract.id === contractId);
export const selectContractsIsLoading = state => state.contracts.isLoading;
export const selectContractsError = state => state.contracts.error;
